<mat-dialog-content class="mat-typography content-dialog-menu">
  <div class="container-fluid" id="menu-container">
    <div id="background-dark"></div>
    <div id="dialog-menu">
      <div class="p-1 d-flex align-items-center flex-column">

        <div class="w-100 text-end m-4" style="margin-top: 23px;">
          <img style="width: 64px; height: 45px; margin-left: 34px;" src="/assets/logos/logo-white.svg" alt="Blukit">
          <button mat-dialog-close class="btn-close-menu" aria-label="Fechar menu" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)">FECHAR
            MENU<i class="bi bi-x" style="font-size: 28px; vertical-align: bottom;" aria-hidden="true"></i></button>
        </div>
        <!-- <div style="width: 90%;max-width: 296px;">
          <input type="text" placeholder="Procurar por um produto" class="input-search" style="font-size: 12px;" aria-label="Procurar por um produto">
          <i class="bi bi-search"
            style="margin-left: -2em; color: var(--main-blue); font-size: 16px; border: none;"></i>
        </div> -->
        <div class="pt-0 pb-3" style="width: 90%;max-width: 296px;">
          <a href="https://portaldolojista.blukit.com.br/auth" target="_blank">
            <button class="btn-portal" style="width: 100% !important;" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)">
              <i class="bi bi-shop" style="width: 17px;
              height: 18px;"></i>
              <span style="font-size: 12px; letter-spacing: 2.04px; line-height: 14px; margin-left: 10px;">PORTAL DO
                LOJISTA</span>
            </button>
          </a>
        </div>
      </div>

      <div class="mx-5">
        <table style="height: 100px;">
          <tbody class="">
            <tr class="menu-mobile">
              <td class="color-light-blue ">
                <a class="color-light-blue" routerLink="/home" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)">Home</a>
              </td>
            </tr>
            <tr class="menu-mobile">
              <td class="color-light-blue py-3">
                <a class="color-light-blue" routerLink="/linhas" style="text-decoration: none;" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)">
                  Produtos
                </a>
              </td>
            </tr>

            <tr class="categoria" *ngFor="let categoria of categories">
              <td class="box-categoria">
                <a (click)="closeMenu()" class="link-categoria " routerLink="/linhas/{{ categoria.slug }}" data-mobile-menu-item data-category-link (keydown)="onMenuItemKeydown($event)">{{
                  categoria.nome
                }}
                </a>
                <button type="button" class="submenu-toggle" *ngIf="categoria.categorias.length > 0"
                  (click)="showSubcategory(true, categoria)"
                  data-mobile-menu-item
                  [attr.data-category-toggle]="categoria.id"
                  (keydown)="onCategoryToggleKeydown($event, categoria)"
                  [attr.aria-label]="categorySelected === categoria.id ? 'Recolher subcategorias de ' + categoria.nome : 'Expandir subcategorias de ' + categoria.nome"
                  [attr.aria-expanded]="categorySelected === categoria.id ? 'true' : 'false'">
                  <i class="bi sub-menu-mobile"
                    [ngClass]="{'bi-chevron-up' : categorySelected === categoria.id,'bi-chevron-down':categorySelected != categoria.id }"
                    aria-hidden="true"></i>
                </button>
              </td>
              <td *ngIf="subCategories && subCategories.length" class="dropdown"
                [ngClass]="{'active' : subCategories[0].parent_id === categorySelected && categorySelected === categoria.id}">
                <div *ngFor="let subCategorie of subCategories">
                  <div class="box-categoria">
                    <a (click)="closeMenu();" href="{{subCategorie.link}}" class="link-subcategoria " data-mobile-menu-item data-subcategory-link [attr.data-parent-category-id]="categoria.id" (keydown)="onSubCategoryLinkKeydown($event, categoria)">{{
                  subCategorie.nome
                }}
                    </a>
                    <button type="button" class="submenu-toggle me-3" *ngIf="subCategorie.subcategorias"
                      (click)="showSubSubcategory(true, subCategorie)"
                      data-mobile-menu-item
                      [attr.data-subcategory-toggle]="subCategorie.id"
                      (keydown)="onSubCategoryToggleKeydown($event, subCategorie)"
                      [attr.aria-label]="subCategorieSelected === subCategorie.id ? 'Recolher subníveis de ' + subCategorie.nome : 'Expandir subníveis de ' + subCategorie.nome"
                      [attr.aria-expanded]="subCategorieSelected === subCategorie.id ? 'true' : 'false'">
                      <i class="bi sub-menu-mobile"
                        [ngClass]="{'bi-chevron-up' : subCategorieSelected === subCategorie.id,'bi-chevron-down':subCategorieSelected != subCategorie.id }"
                        aria-hidden="true"></i>
                    </button>
                  </div>
                  <div *ngIf="subSubCategories && subSubCategories.length" class="dropdown"
                    [ngClass]="{'active' : subSubCategories[0].parent_id === subCategorieSelected && subCategorieSelected === subCategorie.id}">
                  <div *ngFor="let subSubCategorie of subSubCategories">
                      <a *ngIf="subSubCategorie.hasProducts" (click)="closeMenu()" class="link-subsubcategoria"
                        href="{{subSubCategorie.link}}" data-mobile-menu-item data-subsubcategory-link [attr.data-parent-subcategory-id]="subCategorie.id" (keydown)="onSubSubCategoryLinkKeydown($event, subCategorie)">
                        {{ subSubCategorie.nome }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr class="menu-mobile ">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3" routerLink="/onde-encontrar" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)">
                  Onde Encontrar </a>
              </td>
            </tr>
            <tr class="menu-mobile ">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3" href="atendimento" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Atendimento </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/assistencia-tecnica" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Assistência Técnica </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/duvidas-frequentes" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Dúvidas Frequentes </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/fale-conosco" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Fale Conosco </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/financeiro" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Financeiro </a></td>
            </tr>

            <tr>
              <td> <a class="sub-menu-mobile" href="atendimento/ouvidoria" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Ouvidoria </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="https://faleseguro.com.br/welcome?uuid=3941ff81-1ade-4673-ad17-0994d7bf5a41" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)">Canal de Ética</a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" style="cursor: pointer;" (click)="triggerAccessibilityModal()" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Acessibilidade </a></td>
            </tr>

            <tr class="menu-mobile ">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3" href="sobre" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Sobre a Blukit </a></td>
            </tr>
            <tr>
              <td> <a class="sub-menu-mobile" href="sobre/sobre-download" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Downloads </a></td>
            </tr>
            <tr class="categoria">
              <td class="box-categoria">
                <button type="button" (click)="closeMenu()" (mouseover)="showReports()" class="sub-menu-mobile submenu-toggle-text" data-mobile-menu-item data-reports-link (keydown)="onMenuItemKeydown($event)"> Relatório
                  Transparência
                </button>
                <button type="button" class="submenu-toggle"
                  (click)="showReports()"
                  data-mobile-menu-item
                  data-reports-toggle
                  (keydown)="onReportsToggleKeydown($event)"
                  [attr.aria-label]="subcategorieReports.length > 0 ? 'Recolher relatórios de transparência' : 'Expandir relatórios de transparência'"
                  [attr.aria-expanded]="subcategorieReports.length > 0 ? 'true' : 'false'">
                  <i class="bi sub-menu-mobile"
                    [ngClass]="{'bi-chevron-up': subcategorieReports.length > 0, 'bi-chevron-down': subcategorieReports.length === 0 }"
                    aria-hidden="true"></i>
                </button>
              </td>
              <td *ngIf="subcategorieReports.length" class="dropdown"
                [ngClass]="{'active': subcategorieReports.length > 0}">
                <div *ngFor="let subCategorie of subcategorieReports">
                  <div class="box-categoria">
                    <a (click)="closeMenu();" href="{{subCategorie.link}}" class="link-subcategoria " target="_blank" data-mobile-menu-item data-report-item (keydown)="onReportItemKeydown($event)">{{
                      subCategorie.nome }}
                    </a>
                  </div>
                </div>
              </td>
            </tr>

            <tr class="menu-mobile">
              <td class="pt-2 pb-3 box-categoria">
                <button type="button" class="color-light-blue submenu-toggle-text" (click)="toggleDropdown('blukit-pra-voce')"
                  data-mobile-menu-item
                  (keydown)="onMenuItemKeydown($event)"
                  [attr.aria-label]="isDropdownActive('blukit-pra-voce') ? 'Recolher menu Blukit para Você' : 'Expandir menu Blukit para Você'"
                  [attr.aria-expanded]="isDropdownActive('blukit-pra-voce') ? 'true' : 'false'">
                  Blukit para Você
                </button>
                <button type="button" class="submenu-toggle"
                  (click)="toggleDropdown('blukit-pra-voce')"
                  data-mobile-menu-item
                  (keydown)="onMenuItemKeydown($event)"
                  [attr.aria-label]="isDropdownActive('blukit-pra-voce') ? 'Recolher menu Blukit para Você' : 'Expandir menu Blukit para Você'"
                  [attr.aria-expanded]="isDropdownActive('blukit-pra-voce') ? 'true' : 'false'">
                  <i class="bi color-light-blue"
                    [ngClass]="{'bi-chevron-up': isDropdownActive('blukit-pra-voce'), 'bi-chevron-down': !isDropdownActive('blukit-pra-voce') }"
                    aria-hidden="true"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="isDropdownActive('blukit-pra-voce')">
              <td>
                <a class="sub-menu-mobile" href="blog" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Blog </a>
              </td>
            </tr>
            <tr *ngIf="isDropdownActive('blukit-pra-voce')">
              <td>
                <a class="sub-menu-mobile" routerLink="/videos" data-mobile-menu-item (click)="closeMenu()" (keydown)="onMenuItemKeydown($event)"> Vídeos </a>
              </td>
            </tr>
            <tr *ngIf="isDropdownActive('blukit-pra-voce')">
              <td>
                <a class="sub-menu-mobile" routerLink="/top-produtos" data-mobile-menu-item (click)="closeMenu()" (keydown)="onMenuItemKeydown($event)">Top Soluções</a>
              </td>
            </tr>
            <tr *ngIf="isDropdownActive('blukit-pra-voce')">
              <td>
                <a class="sub-menu-mobile" routerLink="/informacoes-tecnicas" data-mobile-menu-item (click)="closeMenu()" (keydown)="onMenuItemKeydown($event)"> Informações Técnicas </a>
              </td>
            </tr>
            <tr *ngIf="isDropdownActive('blukit-pra-voce')">
              <td>
                <a class="sub-menu-mobile" target="_blank" rel="noopener noreferrer" href="https://ead.blukit.com.br/" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> EAD </a>
              </td>
            </tr>

            
            <tr class="menu-mobile">
              <td class="pt-2 pb-3">
                <a class="color-light-blue pt-2 pb-3" routerLink="/informacoes-tecnicas" data-mobile-menu-item (click)="closeMenu()" (keydown)="onMenuItemKeydown($event)">Informações Técnicas</a>
              </td>
            </tr>

            
             <tr class="menu-mobile">
              <td class="pt-2 pb-3"> <a class="color-light-blue pt-2 pb-3"
                  href="https://blukit.portaldetalentos.senior.com.br/"
                  target="_blank" data-mobile-menu-item (keydown)="onMenuItemKeydown($event)"> Trabalhe Conosco </a></td>
              <td>
            </tr>

          </tbody>
        </table>
      </div>

      <div class="mx-5 d-flex justify-content-center flex-column">
        <div>
          <p style="color: white; font-size: 16px; line-height: 19px; letter-spacing: 0.08px;">Siga a Blukit</p>
        </div>
        <div>
          <a href="https://www.instagram.com/canalblukit/?hl=pt-br" target="_blank">
            <img style="margin-right: 10px;" class="social-icons" src="/assets/icons/instagram.svg" alt="Instagram">
          </a>
          <a href="https://pt-br.facebook.com/canalblukit/" target="_blank">
            <img style="margin-right: 10px;" class="social-icons" src="/assets/icons/facebook.svg" alt="Facebook">
          </a>
          <a href="https://www.youtube.com/channel/UCV_SG6uvpUUKaTYnOspC__w" target="_blank">
            <img style="margin-right: 10px;" class="social-icons" src="/assets/icons/youtube.svg" alt="YouTube">
          </a>
          <a href="https://www.linkedin.com/company/canalblukit/" target="_blank">
            <img style="margin-right: 10px;" class="social-icons" src="/assets/icons/linkedin.svg" alt="LinkedIn">
          </a>
        </div>
      </div>

    </div>
  </div>
</mat-dialog-content>
